import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Testimonial01 from "../../../../../assets/image/home-testimonial.png";
import Testimonial02 from "../../../../../assets/image/home-testimonial02.png";
import TestimonialShape from "../../../../../assets/image/testimonial-img-bg-shape.png";
import Image from "../../../../elements/Image";

const testimonials = [
  {
    title: "Reviews from our users",
    text: "From smooth onboarding to outstanding results, see how our platform is making a real difference in the lives of people and businesses just like yours—helping them grow faster, work smarter, and achieve lasting success every day with reliable support and innovative features",
    name: "Emily Johnson",
    role: "CEO of Stripe",
    image: Testimonial01,
  },
  {
    title: "What people say",
    text: "The platform is seamless and has transformed the way our team collaborates. We've seen massive improvements in productivity and customer satisfaction.",
    name: "David Smith",
    role: "Founder of Acme Corp",
    image: Testimonial02,
  },
];

const HomeTestimonial = () => {
  return (
    <section className="relative py-32">
      <div className="w-full max-w-7xl 2xl:max-w-8xl mx-auto">
        <div className="text-white">
          <Swiper
            navigation={{
              nextEl: ".swiper-next",
              prevEl: ".swiper-prev",
            }}
            modules={[Navigation]}
            loop={true}
            className="hometestimonial"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="flex gap-10 justify-between">
                  <div className="space-y-5 max-w-[750px]">
                    <p className="text-primary font-semibold uppercase text-lg">
                      Testimonials
                    </p>
                    <h2 className="text-5xl font-semibold text-white">{item.title}</h2>
                    <div className="text-white text-xl leading-[36px]">
                      <p>{item.text}</p>
                    </div>
                    <div className="font-semibold font-Inter flex flex-col">
                      <span className="text-white text-xl capitalize">{item.name}</span>
                      <span className="text-gray-400 text-[16px]">{item.role}</span>
                    </div>
                  </div>

                  <div className="max-w-[540px] relative overflow-visible pr-[84px] pb-[130px]">
                    
                    <div className="absolute inset-0 -z-10">
                      <div className="absolute right-0 top-0 w-[600px] h-[600px] rounded-full
                    bg-[radial-gradient(circle_at_center,rgba(16,185,129,.35)_0%,rgba(16,185,129,.15)_35%,rgba(16,185,129,0)_70%)]"></div>
                      <div className="absolute right-[0.5rem] top-[9rem] w-[370px] h-[370px]">
                        <Image src={TestimonialShape} alt={""} classes={"object-cover"}/>
                      </div>
                    </div>
                    
                    <div className="rounded-[30px] overflow-hidden aspect-[15/14] relative z-[1]">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="object-cover w-full h-full"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
              <div className="absolute bottom-[168px] left-6 flex gap-3 z-10 w-full justify-center">
                <button className="swiper-prev w-10 h-10 border border-primary rounded-full flex items-center justify-center text-primaryBorder hover:bg-green-500 hover:text-black transition">
                  <i class="fa-light fa-arrow-left"></i>
                </button>
                <button className="swiper-next w-10 h-10 border border-primary rounded-full flex items-center justify-center text-primaryBorder hover:bg-green-500 hover:text-black transition">
                  <i class="fa-light fa-arrow-right"></i>
                </button>
              </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonial;